import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6ed0bb38&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/vstsagent03/user/3333/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ed0bb38')) {
      api.createRecord('6ed0bb38', component.options)
    } else {
      api.reload('6ed0bb38', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6ed0bb38&", function () {
      api.rerender('6ed0bb38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/project/organism/DataDisplay/index.vue"
export default component.exports